import { forwardRef } from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export const IconPdfBoxed = forwardRef((props, ref) => (
  <SvgIcon
    {...props}
    ref={ref}
    viewBox="0 0 24 24"
    data-fill-none
  >
    <path
      d="M1.5 20.75V3.25C1.5 2.28351 2.28351 1.5 3.25 1.5H20.75C21.7165 1.5 22.5 2.28351 22.5 3.25V20.75C22.5 21.7165 21.7165 22.5 20.75 22.5H3.25C2.28351 22.5 1.5 21.7165 1.5 20.75Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12.3583 7.06148C12.0886 5.53874 9.84051 5.62422 9.9867 7.51317C10.1329 9.40212 14.6742 14.5343 17.0365 15.425C19.3988 16.3158 19.6134 14.1736 17.7674 13.5591C15.9214 12.9445 9.77085 15.0902 7.20696 16.4403C4.64307 17.7903 6.75804 19.9562 8.09756 18.5351C9.43708 17.1141 12.6096 8.48016 12.3583 7.06148Z"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
));
